
import { CSSProperties } from "@mui/material/styles/createTypography"
import { IdentityClient } from "api-clients/IdentityClient"
import { PlansClient } from "api-clients/PlansClient"
import { ProductInfoService } from "services/ProductInfoService"
import Container from "components/layout/Container"
import Grid from 'components/layout/grid/Grid'
import Item from 'components/layout/grid/Item'
// import './home.scss';
import Title from "components/labels/Title"
import Subtitle from "components/labels/SubHeading"
import Page from "components/layout/Page"
import Section from "components/layout/Section"
import Button from "components/buttons/Button"
import Box from "components/layout/box/Box"
import Heading from "components/labels/Heading"
import Text from 'components/labels/Text';

import CardFeature from 'views/home/CardFeature'
import { ColorsUtil, MyTheme } from "MyTheme"
import { Avatar, Card, CardActions, CardContent, CardHeader, Divider, IconButton, List, ListItem, ListItemAvatar, ListItemText, Paper, Stack, Step, StepButton, StepLabel, Stepper, useMediaQuery, Zoom } from "@mui/material"
import React, { useEffect, useRef, useState, VideoHTMLAttributes } from "react"
import useVisibility from "hooks/UseVisibility"
import Animation from "components/animations/Animation"
import SubHeading from "components/labels/SubHeading"
import TitleBlock from "components/layout/TitleBlock"
import Icon from "components/icons/Icon"
import { VideoMarker, VideoMarkersController } from "utils/VideoUtil"
import Modal from "components/modals/Dialog"
import Dialog from "components/modals/Dialog"
import { Plan } from "models/Plan"
import { Price } from "models/Price"
import FieldCollection from "components/fields/fieldCollection/FieldCollection"
import TextField from "components/fields/textField/TextField"
import { Link as NavLink, useNavigate } from 'react-router-dom';
import { UserService } from "services/UserService"
import Form from "components/forms/Form"
import TabControl, { TabPanel } from "components/tabs/TabControl"
import Tab from "components/tabs/Tab"
import Tabs from "components/tabs/Tabs"
import ExpansionPanel from "components/transitions/expansionPanel/ExpansionPanel"
import { Bootstrapper } from "Bootstrapper"
import { Context } from "./Context"
import LoadingButton from "components/buttons/LoadingButton"
import { Toast } from "stores/models/Toast"
import { UseToastStore, Update as ToastUpdate } from 'stores/ToastStore';
import Link from "components/buttons/Link"
import { DmsAccount } from "models/DmsAccount"
import { CommonUtil } from "utils/CommonUtil"
import { AdminConsentLink } from "./AdminConsentLink"
import PermissionsDialog from "./PermissionsDialog"
import { MsgraphPermission, MsgraphPermissionType } from "./Permission"


const Integrations = (props: any) => {
    const navigate = useNavigate();
    const userService = new UserService();
    
    const theme = MyTheme();
    const bg1 = theme.palette.grey[200];
    const bg2 = theme.palette.grey['100'];
    const context = Bootstrapper.getInstance<Context>(Context);
    const userId = userService.getActiveUserId();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [isAnimationChaining, setIsAnimationChaining] = useState<boolean | null>(null);
    const [generalValidationMsg, setGeneralValidationMsg] = useState<string>("");
    const [contactValidationMsg, setContactValidationMsg] = useState<string>("");
    const [accountInfo, setAccountInfo] = useState<DmsAccount>(null);
    const [displayPermission, setDisplayPermissions] = useState<boolean>(false);

    const hasGrantedAccess = accountInfo !== null
    const permissionOneDrive = new MsgraphPermission(MsgraphPermissionType.MicrosoftOneDrive, true);
    const permissionSharepoint = new MsgraphPermission(MsgraphPermissionType.MicrosoftSharepoint, false);
    permissionSharepoint.note = "Admin privileges often required";
    const msGraphPermissions = [
        permissionOneDrive,
        permissionSharepoint
    ];

    const handleAnimationChain = () => {
        setIsAnimationChaining(true);
    }


    useEffect(() => {
        loadDataAsync();
    }, []);

    const loadDataAsync= async() => {
        context.setBusyIndicator(true);
        const info = await userService.tryGettingDmsAccountInfo();
        setAccountInfo(info);
        context.setBusyIndicator(false);
    }


    const cancelGraphConsent = async() => {
        await userService.removeDmsAccessAsync();
        const accountInfo = await userService.tryGettingDmsAccountInfo();
        setAccountInfo(accountInfo);
        ToastUpdate(new Toast(true, "Access canceled"));
    }

    const onPermissionResult = async(selectedPermissions: string[]) => {
        setDisplayPermissions(false);
        if(selectedPermissions.length === 0)
            return;
        
        const includeSharepointAccess = MsgraphPermission.hasPermission(MsgraphPermissionType.MicrosoftSharepoint, selectedPermissions);
        const url = await userService.getDmsConsentLinkAsync(includeSharepointAccess);
        window.open(url, '_blank');
    }

    

    return(
        <Container sx={isMobile ? null : {margin: 0}} disableGutters maxWidth="xs">

        <Section disablePadding id="section-plans" bgColor={bg1}>
                <Animation duration="medium" overrideAnimation={isAnimationChaining} onEntering={handleAnimationChain} type='fade' direction='left' transitionDelay={0}>
                    <div>
                        <Grid container alignItems="stretch"spacing={2}>
                            <Grid flexGrow={1} item sm={12} md={12}>
                                <Item sx={{height: '100%'}}>
                                        <div style={{height: '100%'}}>
                                        <ExpansionPanel expanded={true} title="Microsoft OneDrive and Sharepoint">
                                            <Box>
                                                <Form flat
                                                    validationMsg={contactValidationMsg}
                                                    >
                                                        <FieldCollection>
                                                            {!hasGrantedAccess && <TextField isReadOnly disabled label="" value="Integrate Microsoft with Zibbit" endAdornment={<Button size="small" onClick={() => setDisplayPermissions(true)}>Setup</Button>} />}
                                                            {hasGrantedAccess && <TextField
                                                            isReadOnly 
                                                            disabled 
                                                            label="" 
                                                            value={CommonUtil.isNullOrEmpty(accountInfo?.userPrincipalName) ? "Zibbit has access" : accountInfo?.userPrincipalName}
                                                            helperText={<>Manage privacy and access for your Microsoft Account <Link target='_blank' href="https://account.microsoft.com/privacy/app-access">here</Link></> }
                                                            endAdornment={<Button size="small" onClick={async() => await cancelGraphConsent()}>Disconnect</Button>}
                                                            />}
                                                        </FieldCollection>
                                                </Form>
                                                <Box mt={1}>
                                                    <AdminConsentLink/>
                                                </Box>
                                            </Box>             
                                        </ExpansionPanel>
                                        </div>                                    
                                </Item>
                            </Grid>
                        </Grid>
                    </div>
                </Animation>
                <PermissionsDialog open={displayPermission} onResult={(ids: string[]) => onPermissionResult(ids)} permissions={msGraphPermissions} />
        </Section>
        </Container>


    )


}


export default Integrations